<template>
    <transition name="pop">
        <div class="big-pop" v-show="show_flag" v-if="render_flag" :class="{'black-bg':black}">
            <div class="main" :style="{height:height,width:width}">
                <div class="title">
                    <div class="text" :title="tip?title:''">{{ title | titleLimit }}</div>
                    <slot name="tab-title"></slot>
                    <img @click="close" src="~assets/image/back-close.svg">
                </div>
                <z-scrollDiv class="wrap">
                    <slot></slot>
                </z-scrollDiv>
                <div class="btns" v-if="!noBtns">
                    <div class="back-btn blue" v-if="btnshow" @click="save">{{ savetext }}</div>
                    <div class="back-btn" @click="close">{{ canceltext }}</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        // props:["black","height","noBtns","show","title","savetext","canceltext","btnshow"],
        props:{
            show:{  //弹窗控制
                type:Boolean, 
                default:undefined,
            },
            render:{
                type:Boolean,
                default:undefined,
            },
            title:{  //弹窗标题
                type:String,
            },

            // ****功能按钮
            noBtns:{  //不显示控制按钮
                type:Boolean, 
                default:false,
            },
            btnshow:{   //保存———功能按钮显示
                type:Boolean,
                default:false,
            },
            savetext:{   //保存按钮文本
                type:String,
                default:"保存",
            },
            canceltext:{  //取消按钮文本
                type:String,
                default:"取消",
            },

            // *****样式

            black:{   //黑色背景遮罩
                type:Boolean,
                default:false,
            },
            tip:{
                type:Boolean,
                default:false,
            },
            height:{  //主体高度  默认不做限制
                type:String,
                default:"auto",
            },
            width:{  //主体宽度  默认不做限制
                type:String,
                default:"auto",
            },
        },
        computed:{
            render_flag(){
                if(this.render === undefined) return true;
                return this.render;
            },
            show_flag(){
                if(this.show === undefined) return this.render;
                return this.show;
            }

        },
        // computed:{
        //     saveText(){
        //         return this.savetext || "保存";
        //     },
        //     cancelText(){
        //         return this.canceltext || "取消";
        //     },
        //     calc_height(){
        //         return this.height || "auto";  
        //     },
        // },
        methods:{
            close(){  //关弹窗
                this.$emit("cancel");
            }, 
            save(){  //保存/确认
                this.$emit("confirm");
            }
        },
    }
</script>

<style lang="less">
    @import "~src/assets/less/backless/var.less";
    @title_h:50px;

    .big-pop{
        position: fixed;
        width:100%;
        height: 100%;
        left: 0;
        top:0;
        background: rgba(255,255,255,0.7);
        z-index:10;
        // filter: blur(2px);
        // &:before{
        //     content:"";
        //     display:block;
        //     position: absolute;
        //     width:100%;
        //     height: 100%;
        //     top:0;
        //     left:0;
        //     // background:rgba(255,255,255,0.6);
        // }
        

        // 主体部分
        >.main{
            box-shadow: 0 4px 15px 0 #adadad;
            min-width:500px;
            max-height:80%;
            background:#fff;
            position: absolute;
            top:50%;
            left: 50%;
            transform: translate(-50%,-50%);

            
            // 标题
            >.title{
                position: relative;
                height: @title_h;
                line-height:@title_h - 1px;
                box-sizing:border-box;
                border-bottom:1px solid #ddd;
                padding-left: 20px;
                .text{
                    font-size: 14px;
                    font-weight:600;
                    float: left;
                }
                img{
                    position: absolute;
                    top:50%;
                    right:10px;
                    // right: 30px;
                    transform: translateY(-50%);
                    cursor:pointer;
                    padding: 20px;
                }

                // tab  头
                &>div:nth-of-type(2){
                    display:inline-block;
                    margin-left: 60px;
                    margin-bottom: 0;
                    &:after{
                        content:"";
                        display: block;
                        clear: both;
                    }
                    >div{
                        float: left;
                        color:#929292;
                        font-size:12px;
                        line-height: @title_h - 2px;
                        transition:0.3s;
                        cursor:pointer;
                        box-sizing: border-box;
                        border-bottom: 2px solid transparent;
                        &+div{
                            margin-left: 30px;
                        }
                        &:hover{
                            color:@black;
                        }
                        &.active{
                            color:@black;
                            border-bottom: 2px solid @blue;
                        }
                    }
                }

                .clear();

            }

            // slot包裹
            >.wrap{
                height:calc(~"100% - @{title_h}");
                &:after{
                    content: "";
                    display: block;
                    clear:both;
                }
            }

            // 按钮组
            >.btns{
                padding:20px;
                text-align: right;
                .back-btn{
                    display:inline-block;
                    &+.back-btn{
                        margin-left:20px;
                    }
                }
            }

        }

        &.black-bg{
            background:rgba(0,0,0,0.6);
            .main{
                box-shadow: 0 4px 15px 0 #545454;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// windowPop.vue?cb0ddfd8